// pkg72a — green→navy conversion: decorative dark-green surfaces (#1a3a2a/#2a5a4a — banner gradients, featured borders, buttons, toggles, tabs) become NAVY_DEEP #0F1838 → NAVY #1E2761; SEMANTIC greens kept (status/success badges, category chip triads, ✓ text); selected-module card converts as a pair (navy border + pale-navy #F0F2F8 tint) — delivered 2026-07-12
// pkg72 — LawMighty retheme: brand hex sweep (#1a1a1a→#0F1838 NAVY_DEEP, #0f0f0f→#0A1028, #f8f8f8→#F5F1E8 CREAM, #c0392b→#B85042 TERRA) — delivered 2026-07-12
import React, { useState, useEffect } from 'react';
import { useAuth } from '../App';
import { useFirmSettings } from '../contexts/FirmSettingsContext';

// ── BCSO TABLE (Tennessee DHS Income Shares Schedule) ─────────────────────────
// Format: [combined_agi, c1, c2, c3, c4, c5]
const BCSO_TABLE = [
  [150,100,100,100,100,100],[200,111,111,111,111,111],[250,122,122,122,122,122],
  [300,133,133,133,133,133],[350,144,144,144,144,144],[400,155,155,155,155,155],
  [450,166,166,166,166,166],[500,177,177,177,177,177],[550,188,188,188,188,188],
  [600,199,199,199,199,199],[650,210,210,210,210,210],[700,221,221,221,221,221],
  [750,232,232,232,232,232],[800,243,243,243,243,243],[850,248,312,312,312,312],
  [900,257,323,323,323,323],[950,266,334,334,334,334],[1000,275,345,345,345,345],
  [1050,283,356,356,356,356],[1100,292,367,367,367,367],[1150,301,378,378,378,378],
  [1200,310,389,389,389,389],[1250,318,399,399,399,399],[1300,327,410,410,410,410],
  [1350,336,421,421,421,421],[1400,344,431,431,431,431],[1450,353,442,450,450,450],
  [1500,362,453,461,461,461],[1550,371,463,472,472,472],[1600,379,474,484,484,484],
  [1650,388,484,495,495,495],[1700,397,495,506,506,506],[1750,405,505,517,527,527],
  [1800,414,516,528,539,539],[1850,423,526,540,551,551],[1900,431,536,551,562,562],
  [1950,440,547,562,574,574],[2000,449,557,573,585,585],[2050,457,567,584,597,613],
  [2100,466,577,595,608,625],[2150,474,588,606,619,636],[2200,483,598,617,631,648],
  [2250,491,608,628,642,660],[2300,500,618,639,653,671],[2350,509,628,650,665,683],
  [2400,517,638,661,676,694],[2450,526,648,672,688,706],[2500,534,659,683,699,718],
  [2550,543,669,694,710,729],[2600,551,679,705,722,741],[2650,560,689,716,733,752],
  [2700,568,699,727,745,764],[2750,577,709,738,756,776],[2800,585,719,749,767,787],
  [2850,594,729,760,779,799],[2900,602,739,771,790,810],[2950,611,750,782,801,822],
  [3000,619,760,793,813,834],[3050,628,770,804,824,845],[3100,636,780,815,836,857],
  [3150,645,790,826,847,868],[3200,653,800,837,858,880],[3250,662,810,848,870,892],
  [3300,670,820,859,881,903],[3350,679,830,870,893,915],[3400,687,840,881,904,926],
  [3450,696,851,892,915,938],[3500,704,861,903,927,950],[3550,713,871,914,938,961],
  [3600,721,881,925,950,973],[3650,730,891,936,961,984],[3700,738,901,947,972,996],
  [3750,747,911,958,984,1007],[3800,755,921,969,995,1019],[3850,764,931,980,1007,1031],
  [3900,772,941,991,1018,1042],[3950,781,952,1002,1029,1054],[4000,789,962,1013,1041,1066],
  [4050,797,971,1023,1051,1076],[4100,806,981,1034,1062,1087],[4150,814,990,1044,1072,1097],
  [4200,822,1000,1054,1082,1107],[4250,830,1009,1064,1092,1117],[4300,838,1018,1074,1102,1127],
  [4350,846,1027,1083,1112,1137],[4400,854,1037,1093,1122,1147],[4450,862,1046,1103,1132,1157],
  [4500,870,1055,1113,1142,1167],[4550,878,1064,1123,1152,1177],[4600,886,1073,1132,1162,1186],
  [4650,894,1082,1142,1172,1196],[4700,902,1091,1152,1182,1206],[4750,910,1101,1162,1192,1216],
  [4800,918,1110,1171,1202,1226],[4850,926,1119,1181,1212,1236],[4900,934,1128,1191,1221,1246],
  [4950,942,1137,1201,1231,1256],[5000,950,1146,1210,1241,1266],[5050,957,1154,1219,1250,1275],
  [5100,964,1163,1228,1259,1284],[5150,971,1171,1237,1268,1292],[5200,979,1180,1246,1277,1301],
  [5250,986,1188,1255,1285,1310],[5300,993,1196,1264,1294,1319],[5350,1000,1205,1273,1303,1328],
  [5400,1007,1213,1281,1312,1336],[5450,1014,1221,1290,1321,1345],[5500,1021,1229,1299,1330,1354],
  [5550,1028,1237,1308,1338,1362],[5600,1035,1246,1317,1347,1371],[5650,1042,1254,1326,1356,1380],
  [5700,1049,1262,1335,1365,1388],[5750,1056,1270,1344,1374,1397],[5800,1063,1278,1352,1383,1406],
  [5850,1070,1286,1361,1391,1414],[5900,1077,1294,1370,1400,1423],[5950,1084,1303,1379,1409,1432],
  [6000,1091,1311,1388,1418,1441],[6050,1098,1319,1397,1427,1449],[6100,1105,1327,1406,1436,1458],
  [6150,1112,1335,1415,1445,1467],[6200,1119,1343,1424,1454,1476],[6250,1126,1351,1433,1463,1484],
  [6300,1133,1359,1442,1471,1493],[6350,1140,1367,1451,1480,1502],[6400,1147,1375,1460,1489,1511],
  [6450,1154,1383,1469,1498,1519],[6500,1161,1391,1478,1507,1528],[6550,1168,1399,1487,1516,1537],
  [6600,1175,1407,1495,1524,1545],[6650,1181,1414,1503,1532,1553],[6700,1188,1421,1511,1540,1561],
  [6750,1194,1428,1519,1548,1569],[6800,1200,1436,1527,1556,1577],[6850,1206,1443,1535,1564,1585],
  [6900,1213,1450,1543,1572,1593],[6950,1219,1458,1550,1580,1601],[7000,1225,1465,1558,1588,1609],
  [7050,1231,1472,1566,1596,1617],[7100,1238,1479,1574,1604,1625],[7150,1244,1486,1582,1612,1633],
  [7200,1250,1494,1590,1620,1641],[7250,1256,1501,1598,1628,1649],[7300,1263,1508,1606,1636,1657],
  [7350,1269,1515,1614,1644,1665],[7400,1275,1522,1622,1652,1673],[7450,1281,1529,1630,1660,1681],
  [7500,1288,1536,1638,1668,1689],[7550,1294,1543,1645,1676,1697],[7600,1300,1550,1653,1683,1705],
  [7650,1306,1557,1661,1691,1712],[7700,1311,1563,1668,1698,1719],[7750,1317,1569,1674,1704,1726],
  [7800,1322,1575,1681,1711,1733],[7850,1328,1581,1688,1718,1740],[7900,1333,1587,1695,1724,1747],
  [7950,1339,1593,1702,1731,1753],[8000,1344,1599,1709,1737,1760],[8050,1350,1605,1716,1744,1767],
  [8100,1355,1611,1722,1751,1774],[8150,1361,1617,1729,1757,1781],[8200,1366,1623,1736,1764,1788],
  [8250,1372,1629,1743,1771,1795],[8300,1377,1635,1750,1777,1801],[8350,1383,1641,1757,1784,1808],
  [8400,1388,1647,1764,1790,1815],[8450,1394,1653,1771,1797,1822],[8500,1399,1659,1778,1804,1829],
  [8550,1405,1665,1785,1810,1836],[8600,1410,1671,1792,1817,1843],[8650,1416,1677,1799,1824,1850],
  [8700,1421,1683,1806,1830,1857],[8750,1427,1689,1813,1837,1864],[8800,1432,1695,1820,1843,1871],
  [8850,1438,1701,1827,1850,1877],[8900,1443,1707,1833,1857,1884],[8950,1449,1713,1840,1863,1891],
  [9000,1454,1719,1847,1870,1898],[9050,1460,1725,1854,1877,1905],[9100,1465,1731,1861,1883,1912],
  [9150,1471,1737,1868,1890,1919],[9200,1476,1743,1875,1896,1926],[9250,1482,1749,1882,1903,1933],
  [9300,1487,1755,1889,1910,1940],[9350,1493,1761,1896,1916,1947],[9400,1498,1767,1903,1923,1954],
  [9450,1504,1773,1910,1929,1961],[9500,1509,1779,1917,1936,1968],[9550,1515,1785,1924,1943,1975],
  [9600,1520,1791,1930,1949,1981],[9650,1526,1797,1937,1956,1988],[9700,1531,1803,1944,1963,1995],
  [9750,1537,1809,1951,1969,2002],[9800,1542,1815,1958,1976,2009],[9850,1548,1820,1965,1982,2016],
  [9900,1553,1826,1972,1989,2023],[9950,1559,1832,1979,1996,2030],[10000,1564,1838,1986,2002,2037],
  [10500,1618,1900,2054,2073,2107],[11000,1671,1962,2122,2143,2177],[11500,1725,2024,2191,2213,2247],
  [12000,1778,2086,2259,2283,2318],[12500,1832,2148,2327,2353,2388],[13000,1885,2210,2395,2423,2458],
  [13500,1939,2272,2464,2494,2528],[14000,1992,2334,2532,2564,2598],[14500,2046,2395,2600,2634,2668],
  [15000,2099,2457,2668,2704,2738],[15500,2153,2519,2737,2774,2808],[16000,2206,2581,2805,2845,2879],
  [16500,2260,2643,2873,2915,2949],[17000,2313,2705,2941,2985,3019],[17500,2367,2767,3010,3055,3089],
  [18000,2420,2829,3078,3125,3159],[18500,2474,2891,3146,3196,3230],[19000,2527,2953,3214,3266,3300],
  [19500,2581,3015,3283,3336,3370],[20000,2634,3077,3351,3406,3440],[20500,2686,3136,3416,3473,3506],
  [21000,2737,3195,3481,3540,3572],[21500,2789,3254,3546,3607,3638],[22000,2840,3313,3611,3674,3704],
  [22500,2892,3372,3676,3741,3770],[23000,2943,3430,3741,3808,3836],[23500,2995,3489,3806,3875,3902],
  [24000,3046,3548,3871,3942,3968],[24500,3098,3607,3936,4009,4034],[25000,3149,3666,4001,4076,4100],
  [25500,3201,3725,4066,4143,4166],[26000,3252,3784,4131,4210,4232],[26500,3304,3843,4196,4277,4298],
  [27000,3355,3902,4261,4344,4364],[27500,3407,3961,4326,4411,4430],[28000,3458,4020,4391,4478,4496],
  [28250,3484,4050,4424,4512,4529],
];

const HIGH_RATES = [0.0681, 0.0722, 0.0777, 0.0805, 0.0866];
const MAX_PCSO   = [2100, 3200, 4100, 4600, 5000];

function lookupBCSO(combinedAgi, numChildren) {
  const nc = Math.max(1, Math.min(Math.floor(numChildren), 5));
  const col = nc; // index 1-5

  if (combinedAgi <= 0) return 100;

  if (combinedAgi > 28250) {
    const base = BCSO_TABLE[BCSO_TABLE.length - 1][col];
    const rate = HIGH_RATES[nc - 1];
    return Math.round((base + (combinedAgi - 28250) * rate) * 100) / 100;
  }

  // Round UP to nearest $50
  const lookupIncome = Math.min(28250, Math.max(150, Math.ceil(combinedAgi / 50) * 50));
  const incomes = BCSO_TABLE.map(r => r[0]);
  let idx = incomes.findIndex(v => v >= lookupIncome);
  if (idx === -1) idx = BCSO_TABLE.length - 1;
  return BCSO_TABLE[idx][col];
}

function fmt2(v) { return Math.round(parseFloat(v || 0) * 100) / 100; }
function fv(v) { return parseFloat(String(v || 0).replace(/[$,]/g, '')) || 0; }

function calculateCS(inputs) {
  const {
    motherGross, fatherGross, motherFedBenefit = 0, fatherFedBenefit = 0,
    motherSeTax = 0, fatherSeTax = 0, motherInhome = 0, fatherInhome = 0,
    motherNotinhome = 0, fatherNotinhome = 0, motherHealthIns = 0, fatherHealthIns = 0,
    motherMedical = 0, fatherMedical = 0, motherChildcare = 0, fatherChildcare = 0,
    prpIsMother = true, motherDays, fatherDays, numChildren = 1,
  } = inputs;

  // AGI
  const mSub   = fmt2(fv(motherGross) + fv(motherFedBenefit) - fv(motherSeTax));
  const fSub   = fmt2(fv(fatherGross) + fv(fatherFedBenefit) - fv(fatherSeTax));
  const mAgi   = fmt2(Math.max(0, mSub - fv(motherInhome) - fv(motherNotinhome)));
  const fAgi   = fmt2(Math.max(0, fSub - fv(fatherInhome) - fv(fatherNotinhome)));
  const cAgi   = fmt2(mAgi + fAgi);

  // PI
  const mPi = cAgi > 0 ? Math.round(mAgi / cAgi * 100) / 100 : 0;
  const fPi = cAgi > 0 ? Math.round(fAgi / cAgi * 100) / 100 : 0;

  // BCSO
  const bcso = lookupBCSO(cAgi, numChildren);

  // ARP/PRP
  const arpDays = prpIsMother ? fv(fatherDays) : fv(motherDays);
  const prpDays = prpIsMother ? fv(motherDays) : fv(fatherDays);
  const arpPi   = prpIsMother ? fPi : mPi;
  const prpPi   = prpIsMother ? mPi : fPi;

  // Line 4a: ARP's share of BCSO
  const line4a = fmt2(bcso * arpPi);

  // Parenting time adjustment (92+ days)
  let line6a = 0, line6b = line4a;
  if (arpDays >= 92) {
    line6a = fmt2(((2 * arpDays / 182.5) - 1) * bcso * prpPi * -1);
    line6b = fmt2(Math.max(0, line4a + line6a));
  }

  const line7 = line6b; // Calculated BCSO

  // Expenses
  const mTotalExp = fmt2(fv(motherHealthIns) + fv(motherMedical) + fv(motherChildcare));
  const fTotalExp = fmt2(fv(fatherHealthIns) + fv(fatherMedical) + fv(fatherChildcare));
  const prpExpShare = fmt2(prpPi * (prpIsMother ? fTotalExp : mTotalExp));
  const arpExpShare = fmt2(arpPi * (prpIsMother ? mTotalExp : fTotalExp));

  // ASO
  const prpAso = prpExpShare;
  const arpAso = fmt2(line7 + arpExpShare);

  // PCSO
  const pcso = Math.min(Math.floor(Math.abs(arpAso - prpAso)), MAX_PCSO[Math.min(numChildren, 5) - 1]);

  // Who pays
  const payorIsMother = !prpIsMother; // ARP pays
  const payorLabel = payorIsMother ? 'Mother' : 'Father';
  const payeeLabel = payorIsMother ? 'Father' : 'Mother';

  return {
    motherAgi: mAgi, fatherAgi: fAgi, combinedAgi: cAgi,
    motherPi: Math.round(mPi * 100), fatherPi: Math.round(fPi * 100),
    bcso, arpDays, line4a: fmt2(line4a), line6a: fmt2(line6a), line6b: fmt2(line6b),
    line7: fmt2(line7), mTotalExp, fTotalExp, prpExpShare, arpExpShare,
    prpAso: fmt2(prpAso), arpAso: fmt2(arpAso), pcso,
    payorLabel, payeeLabel, prpIsMother,
  };
}

function fmt$(n) {
  return `$${(n || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

function InputRow({ label, value, onChange, note }) {
  return (
    <div style={{ display: 'grid', gridTemplateColumns: '1fr 160px', gap: 12, alignItems: 'center', marginBottom: 10 }}>
      <div>
        <div style={{ fontFamily: 'Arial, sans-serif', fontSize: 13 }}>{label}</div>
        {note && <div style={{ fontFamily: 'Arial, sans-serif', fontSize: 11, color: '#888' }}>{note}</div>}
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 6 }}>
        <input type="number" min="0" step="0.01" value={value[0] || ''} onChange={e => onChange([e.target.value, value[1]])}
          placeholder="Mother" style={{ padding: '6px 8px', border: '1px solid #ddd', borderRadius: 3, fontSize: 13, textAlign: 'right', width: '100%' }} />
        <input type="number" min="0" step="0.01" value={value[1] || ''} onChange={e => onChange([value[0], e.target.value])}
          placeholder="Father" style={{ padding: '6px 8px', border: '1px solid #ddd', borderRadius: 3, fontSize: 13, textAlign: 'right', width: '100%' }} />
      </div>
    </div>
  );
}

function ResultRow({ label, mVal, fVal, bold, shade }) {
  const style = {
    display: 'grid', gridTemplateColumns: '1fr 90px 90px',
    background: shade ? '#f0f4ff' : 'transparent',
    padding: '5px 10px', borderBottom: '1px solid #f0f0f0',
    fontFamily: 'Arial, sans-serif', fontSize: 13,
    fontWeight: bold ? 700 : 400,
  };
  return (
    <div style={style}>
      <div>{label}</div>
      <div style={{ textAlign: 'right' }}>{mVal}</div>
      <div style={{ textAlign: 'right' }}>{fVal}</div>
    </div>
  );
}

export default function ChildSupportPage() {
  const { client } = useAuth();
  const { firm } = useFirmSettings();

  const [numChildren, setNumChildren] = useState(1);
  const [prpIsMother, setPrpIsMother] = useState(true);
  const [motherDays, setMotherDays]   = useState('183');
  const [fatherDays, setFatherDays]   = useState('182');
  const daysTotal = (parseFloat(motherDays) || 0) + (parseFloat(fatherDays) || 0);
  const daysValid = daysTotal === 365;
  const [gross,      setGross]        = useState(['', '']);
  const [fedBenefit, setFedBenefit]   = useState(['0', '0']);
  const [seTax,      setSeTax]        = useState(['0', '0']);
  const [motherInhomeKids,    setMotherInhomeKids]    = useState('0');
  const [fatherInhomeKids,    setFatherInhomeKids]    = useState('0');
  const [motherNotinhomeKids, setMotherNotinhomeKids] = useState('0');
  const [fatherNotinhomeKids, setFatherNotinhomeKids] = useState('0');
  const [motherNotinhomePaid, setMotherNotinhomePaid] = useState('0');
  const [fatherNotinhomePaid, setFatherNotinhomePaid] = useState('0');
  const [healthIns,  setHealthIns]    = useState(['0', '0']);
  const [medical,    setMedical]      = useState(['0', '0']);
  const [childcare,  setChildcare]    = useState(['0', '0']);
  const [result,     setResult]       = useState(null);

  function calculate() {
    if (!gross[0] && !gross[1]) return;
    // Compute in-home credits: 75% of theoretical BCSO for other children
    const mInhomeKids    = parseInt(motherInhomeKids)    || 0;
    const fInhomeKids    = parseInt(fatherInhomeKids)    || 0;
    const mNotinhomeKids = parseInt(motherNotinhomeKids) || 0;
    const fNotinhomeKids = parseInt(fatherNotinhomeKids) || 0;
    const mGross = fv(gross[0]);
    const fGross = fv(gross[1]);
    // In-home: 75% of BCSO based on parent's own gross + # in-home kids
    const mInhomeCredit    = mInhomeKids > 0    ? fmt2(lookupBCSO(mGross, mInhomeKids) * 0.75)    : 0;
    const fInhomeCredit    = fInhomeKids > 0    ? fmt2(lookupBCSO(fGross, fInhomeKids) * 0.75)    : 0;
    // Not-in-home: lesser of 75% of theoretical BCSO or actual documented support paid
    const mNotinhomeBcso   = mNotinhomeKids > 0 ? fmt2(lookupBCSO(mGross, mNotinhomeKids) * 0.75) : 0;
    const fNotinhomeBcso   = fNotinhomeKids > 0 ? fmt2(lookupBCSO(fGross, fNotinhomeKids) * 0.75) : 0;
    const mNotinhomeCredit = mNotinhomeKids > 0 ? fmt2(Math.min(mNotinhomeBcso, fv(motherNotinhomePaid))) : 0;
    const fNotinhomeCredit = fNotinhomeKids > 0 ? fmt2(Math.min(fNotinhomeBcso, fv(fatherNotinhomePaid))) : 0;

    const r = calculateCS({
      motherGross: mGross, fatherGross: fGross,
      motherFedBenefit: fv(fedBenefit[0]), fatherFedBenefit: fv(fedBenefit[1]),
      motherSeTax: fv(seTax[0]), fatherSeTax: fv(seTax[1]),
      motherInhome: mInhomeCredit, fatherInhome: fInhomeCredit,
      motherNotinhome: mNotinhomeCredit, fatherNotinhome: fNotinhomeCredit,
      motherHealthIns: fv(healthIns[0]), fatherHealthIns: fv(healthIns[1]),
      motherMedical: fv(medical[0]), fatherMedical: fv(medical[1]),
      motherChildcare: fv(childcare[0]), fatherChildcare: fv(childcare[1]),
      prpIsMother, motherDays: parseFloat(motherDays) || 183,
      fatherDays: parseFloat(fatherDays) || 182,
      numChildren: parseInt(numChildren) || 1,
      mInhomeCredit, fInhomeCredit, mNotinhomeCredit, fNotinhomeCredit,
    });
    setResult(r);
  }

  const hdrStyle = { fontFamily: 'Arial, sans-serif', fontSize: 11, fontWeight: 700,
    textTransform: 'uppercase', letterSpacing: '0.04em', padding: '6px 10px',
    background: '#0F1838', color: '#fff', textAlign: 'right' };

  return (
    <div>
      <h1 className="page-title">Child Support Calculator</h1>
      <p className="page-subtitle">
        Tennessee Income Shares calculator based on the official DHS Guidelines.
        Results are estimates only — your attorney will determine the final order amount.
      </p>

      <div className="card">
        <div className="card-title" style={{ fontSize: 15, marginBottom: 16 }}>Case Information</div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 16, marginBottom: 16 }}>
          <div className="form-group" style={{ margin: 0 }}>
            <label>Number of Children</label>
            <select value={numChildren} onChange={e => setNumChildren(e.target.value)}>
              {[1,2,3,4,5].map(n => <option key={n} value={n}>{n}</option>)}
            </select>
          </div>
          <div className="form-group" style={{ margin: 0 }}>
            <label>Primary Residential Parent (PRP)</label>
            <select value={prpIsMother ? 'mother' : 'father'} onChange={e => setPrpIsMother(e.target.value === 'mother')}>
              <option value="mother">Mother</option>
              <option value="father">Father</option>
            </select>
          </div>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 20 }}>
          <div className="form-group" style={{ margin: 0 }}>
            <label>Mother's Days per Year</label>
            <input type="number" min="0" max="365" step="0.5" value={motherDays}
              onChange={e => {
                const m = e.target.value;
                setMotherDays(m);
                const mNum = parseFloat(m) || 0;
                if (mNum >= 0 && mNum <= 365) setFatherDays(String(365 - mNum));
              }} />
          </div>
          <div className="form-group" style={{ margin: 0 }}>
            <label>Father's Days per Year</label>
            <input type="number" min="0" max="365" step="0.5" value={fatherDays}
              onChange={e => {
                const f = e.target.value;
                setFatherDays(f);
                const fNum = parseFloat(f) || 0;
                if (fNum >= 0 && fNum <= 365) setMotherDays(String(365 - fNum));
              }} />
          </div>
        </div>

        {/* Days total display */}
        <div style={{
          display: 'flex', alignItems: 'center', gap: 12, marginBottom: 16,
          padding: '8px 12px', borderRadius: 4,
          background: daysValid ? '#f0faf5' : '#fdf0ef',
          border: `1px solid ${daysValid ? '#b7e3cf' : '#f5c6c3'}`,
        }}>
          <span style={{ fontSize: 13, fontFamily: 'Arial, sans-serif', color: daysValid ? '#1e7e5e' : '#B85042', fontWeight: 600 }}>
            {daysValid ? '✓' : '⚠'} Total days: {daysTotal} / 365
          </span>
          {!daysValid && (
            <span style={{ fontSize: 12, fontFamily: 'Arial, sans-serif', color: '#B85042' }}>
              Days must add up to exactly 365. Editing one field auto-adjusts the other.
            </span>
          )}
        </div>

        {/* Column headers for Mother/Father inputs */}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 160px', gap: 12, marginBottom: 6 }}>
          <div />
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 6 }}>
            <div style={{ fontFamily: 'Arial, sans-serif', fontSize: 11, fontWeight: 700, textAlign: 'center', color: '#555', textTransform: 'uppercase', letterSpacing: '0.04em' }}>Mother</div>
            <div style={{ fontFamily: 'Arial, sans-serif', fontSize: 11, fontWeight: 700, textAlign: 'center', color: '#555', textTransform: 'uppercase', letterSpacing: '0.04em' }}>Father</div>
          </div>
        </div>

        <div className="section-head" style={{ marginTop: 8 }}>Income</div>
        <InputRow label="Gross Monthly Income" value={gross} onChange={setGross} />
        <InputRow label="Federal Benefit (add)" value={fedBenefit} onChange={setFedBenefit} note="SS, VA, disability received on behalf of child" />
        <InputRow label="Self-Employment Tax (subtract)" value={seTax} onChange={setSeTax} />
        {/* In-home credit — number of other children living with each parent */}
        <div style={{ marginBottom: 10 }}>
          <div style={{ fontFamily: 'Arial, sans-serif', fontSize: 13, marginBottom: 4 }}>
            Other Children Living In Home (not subject to this order)
          </div>
          <div style={{ fontSize: 11, fontFamily: 'Arial, sans-serif', color: '#888', marginBottom: 6 }}>
            Credit = 75% of theoretical BCSO based on parent's gross income
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 160px', gap: 12, alignItems: 'center' }}>
            <div />
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 6 }}>
              <input type="number" min="0" step="1" value={motherInhomeKids}
                onChange={e => setMotherInhomeKids(e.target.value)}
                placeholder="Mother" style={{ padding: '6px 8px', border: '1px solid #ddd', borderRadius: 3, fontSize: 13, textAlign: 'right', width: '100%' }} />
              <input type="number" min="0" step="1" value={fatherInhomeKids}
                onChange={e => setFatherInhomeKids(e.target.value)}
                placeholder="Father" style={{ padding: '6px 8px', border: '1px solid #ddd', borderRadius: 3, fontSize: 13, textAlign: 'right', width: '100%' }} />
            </div>
          </div>
        </div>

        {/* Not-in-home credit */}
        <div style={{ marginBottom: 10 }}>
          <div style={{ fontFamily: 'Arial, sans-serif', fontSize: 13, marginBottom: 4 }}>
            Other Children Not In Home (court-ordered support)
          </div>
          <div style={{ fontSize: 11, fontFamily: 'Arial, sans-serif', color: '#888', marginBottom: 6 }}>
            Credit = lesser of 75% of theoretical BCSO or actual documented monthly support paid
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 160px', gap: 12, alignItems: 'center', marginBottom: 6 }}>
            <div style={{ fontFamily: 'Arial, sans-serif', fontSize: 12, color: '#555' }}>Number of children</div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 6 }}>
              <input type="number" min="0" step="1" value={motherNotinhomeKids}
                onChange={e => setMotherNotinhomeKids(e.target.value)}
                placeholder="Mother" style={{ padding: '6px 8px', border: '1px solid #ddd', borderRadius: 3, fontSize: 13, textAlign: 'right', width: '100%' }} />
              <input type="number" min="0" step="1" value={fatherNotinhomeKids}
                onChange={e => setFatherNotinhomeKids(e.target.value)}
                placeholder="Father" style={{ padding: '6px 8px', border: '1px solid #ddd', borderRadius: 3, fontSize: 13, textAlign: 'right', width: '100%' }} />
            </div>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 160px', gap: 12, alignItems: 'center' }}>
            <div style={{ fontFamily: 'Arial, sans-serif', fontSize: 12, color: '#555' }}>Actual monthly support paid</div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 6 }}>
              <input type="number" min="0" step="0.01" value={motherNotinhomePaid}
                onChange={e => setMotherNotinhomePaid(e.target.value)}
                placeholder="Mother" style={{ padding: '6px 8px', border: '1px solid #ddd', borderRadius: 3, fontSize: 13, textAlign: 'right', width: '100%' }} />
              <input type="number" min="0" step="0.01" value={fatherNotinhomePaid}
                onChange={e => setFatherNotinhomePaid(e.target.value)}
                placeholder="Father" style={{ padding: '6px 8px', border: '1px solid #ddd', borderRadius: 3, fontSize: 13, textAlign: 'right', width: '100%' }} />
            </div>
          </div>
        </div>

        <div className="section-head">Additional Expenses</div>
        <InputRow label="Health Insurance Premium" value={healthIns} onChange={setHealthIns} note="Monthly cost to insure the child(ren)" />
        <InputRow label="Extraordinary Medical" value={medical} onChange={setMedical} />
        <InputRow label="Work-Related Childcare" value={childcare} onChange={setChildcare} />

        <div className="btn-row" style={{ marginTop: 20 }}>
          <button className="btn btn-primary" onClick={calculate} disabled={!daysValid}>
            Calculate Child Support
          </button>
          {!daysValid && (
            <span style={{ fontSize: 12, fontFamily: 'Arial, sans-serif', color: '#B85042', alignSelf: 'center' }}>
              Fix days total before calculating
            </span>
          )}
        </div>
      </div>

      {/* Results */}
      {result && (
        <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
          {/* Result header */}
          <div style={{ background: '#0F1838', color: '#fff', padding: '16px 20px', textAlign: 'center' }}>
            <div style={{ fontSize: 12, fontFamily: 'Arial, sans-serif', opacity: 0.8, textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 6 }}>
              Preliminary Child Support Order (PCSO)
            </div>
            <div style={{ fontSize: 36, fontWeight: 700, fontFamily: 'Arial, sans-serif' }}>
              {fmt$(result.pcso)}<span style={{ fontSize: 16, opacity: 0.8 }}>/month</span>
            </div>
            <div style={{ fontSize: 14, fontFamily: 'Arial, sans-serif', marginTop: 8, opacity: 0.9 }}>
              {result.payorLabel} pays {result.payeeLabel}
            </div>
          </div>

          {/* Column headers */}
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 90px 90px', borderBottom: '2px solid #ddd' }}>
            <div style={{ ...hdrStyle, textAlign: 'left' }}>Line Item</div>
            <div style={hdrStyle}>Mother</div>
            <div style={hdrStyle}>Father</div>
          </div>

          <ResultRow label="Gross Monthly Income" mVal={fmt$(fv(gross[0]))} fVal={fmt$(fv(gross[1]))} />
          {(result.mInhomeCredit > 0 || result.fInhomeCredit > 0) && (
            <ResultRow label="In-Home Children Credit" mVal={result.mInhomeCredit > 0 ? `(${fmt$(result.mInhomeCredit)})` : '—'} fVal={result.fInhomeCredit > 0 ? `(${fmt$(result.fInhomeCredit)})` : '—'} />
          )}
          {(result.mNotinhomeCredit > 0 || result.fNotinhomeCredit > 0) && (
            <ResultRow label="Not-In-Home Children Credit" mVal={result.mNotinhomeCredit > 0 ? `(${fmt$(result.mNotinhomeCredit)})` : '—'} fVal={result.fNotinhomeCredit > 0 ? `(${fmt$(result.fNotinhomeCredit)})` : '—'} />
          )}
          <ResultRow label="Adjusted Gross Income (AGI)" mVal={fmt$(result.motherAgi)} fVal={fmt$(result.fatherAgi)} bold shade />
          <ResultRow label="Combined AGI" mVal={fmt$(result.combinedAgi)} fVal="" bold />
          <ResultRow label="Proportionate Income Share (PI)" mVal={`${result.motherPi}%`} fVal={`${result.fatherPi}%`} />
          <ResultRow label={`BCSO (${numChildren} child${numChildren > 1 ? 'ren' : ''})`} mVal={fmt$(result.bcso)} fVal="" bold shade />
          <ResultRow label="ARP's Share of BCSO (Line 4a)" mVal={result.prpIsMother ? '' : fmt$(result.line4a)} fVal={result.prpIsMother ? fmt$(result.line4a) : ''} />
          {result.arpDays >= 92 && <>
            <ResultRow label={`Parenting Time Adjustment (Line 6a) — ${Math.round(result.arpDays)} ARP days`}
              mVal={result.prpIsMother ? '' : fmt$(result.line6a)}
              fVal={result.prpIsMother ? fmt$(result.line6a) : ''} />
            <ResultRow label="Adjusted BCSO (Line 6b)" mVal={result.prpIsMother ? '' : fmt$(result.line6b)} fVal={result.prpIsMother ? fmt$(result.line6b) : ''} shade />
          </>}
          <ResultRow label="Calculated BCSO (Line 7)" mVal={result.prpIsMother ? '' : fmt$(result.line7)} fVal={result.prpIsMother ? fmt$(result.line7) : ''} bold />
          <ResultRow label="Total Additional Expenses" mVal={fmt$(result.mTotalExp)} fVal={fmt$(result.fTotalExp)} />
          <ResultRow label="Each Parent's Share of Other's Expenses (Line 10)" mVal={fmt$(result.prpIsMother ? result.prpExpShare : result.arpExpShare)} fVal={fmt$(result.prpIsMother ? result.arpExpShare : result.prpExpShare)} />
          <ResultRow label="Additional Support Obligation (ASO — Line 11)" mVal={fmt$(result.prpIsMother ? result.prpAso : result.arpAso)} fVal={fmt$(result.prpIsMother ? result.arpAso : result.prpAso)} bold shade />

          <div style={{ padding: '16px 20px', background: '#F5F1E8', borderTop: '2px solid #0F1838' }}>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
              <div style={{ textAlign: 'center', background: '#0F1838', borderRadius: 4, padding: '12px 8px', color: '#fff' }}>
                <div style={{ fontSize: 11, fontFamily: 'Arial, sans-serif', opacity: 0.8, textTransform: 'uppercase', letterSpacing: '0.04em', marginBottom: 4 }}>PCSO (Guideline Amount)</div>
                <div style={{ fontSize: 24, fontWeight: 700, fontFamily: 'Arial, sans-serif' }}>{fmt$(result.pcso)}/mo</div>
              </div>
              <div style={{ textAlign: 'center', background: '#2f5496', borderRadius: 4, padding: '12px 8px', color: '#fff' }}>
                <div style={{ fontSize: 11, fontFamily: 'Arial, sans-serif', opacity: 0.8, textTransform: 'uppercase', letterSpacing: '0.04em', marginBottom: 4 }}>Annual Amount</div>
                <div style={{ fontSize: 24, fontWeight: 700, fontFamily: 'Arial, sans-serif' }}>{fmt$(result.pcso * 12)}/yr</div>
              </div>
            </div>
            <p style={{ fontSize: 11, fontFamily: 'Arial, sans-serif', color: '#888', marginTop: 12, marginBottom: 0, textAlign: 'center' }}>
              This is a preliminary calculation only. The Final Child Support Order (FCSO) is set by the court and may deviate from the guideline amount.
              Contact{firm.firm_name ? ' ' + firm.firm_name : ' the firm'}{firm.phone ? ' at ' + firm.phone : ''} to discuss your specific situation.
            </p>
          </div>
        </div>
      )}
    </div>
  );
}
